import React, { useContext, useEffect, useState } from 'react';
import cn from 'classnames';
import useQueryString from '../../../hooks/use-query-string';
import { CustomerContext } from '../../../contexts/CustomerContext';
import styles from './GetAccessCode.module.scss';
import FacialRecognitionForm from './FacialRecognitionForm';
import { Cart, School } from '../../../models';

export default function MobileUpload() {
  const { customer, setCustomer } = useContext(CustomerContext);
  const { email: emailParam, schoolId: schoolParam } = useQueryString(); // email (for cart) and schoolId for finding student
  const [email, setEmail] = useState(emailParam);

  useEffect(() => {
    if (!email) return;
    setCustomer({ ...customer, email });
  }, [email]);

  useEffect(() => {
    if (!email) return;

    async function syncCustomer() {
      const newCart = new Cart({ email });
      await newCart.save();
      const { data: school } = await School.find(schoolParam);

      setCustomer({ ...customer, cart: newCart, currentSchool: school });
    }

    syncCustomer();
  }, [email, schoolParam]);

  return (
    <div className={cn(styles.container, styles.getAccessCodePage, styles.column)}>
      <div className={styles.text}>
        <p>Please upload an image of your student and we will do our best to find them.</p>
        <p>You will be redirected to package selection if your student is found.</p>
      </div>
      <FacialRecognitionForm />
    </div>
  );
}
